module.exports = {
  alioss: {
    host: {
      staging: 'fresh-admin.chengbao88.com',
      production: 'fresh-admin.chengbao68.com'
    },
    bucket: {
      staging: 'fresh-admin',
      production: 'fresh-admin-pro'
    },
    image_bucket: 'fresh-picture',
    image_region: 'oss-cn-hangzhou',
    region: {
      staging: 'oss-cn-shanghai',
      production: 'oss-cn-beijing'
    },
    ACCESS_KEY: 'LTAIwvNkxVg6a3Ax',
    SECRET_KEY: 'sfnRvAPzdQpWEMcMzzZ4vzpX8XaC42',
    upload_dir: 'dist'
  },
  qqmap: {
    key: 'BNZBZ-6ZFCF-HIXJC-JZFYK-OFNRS-JWFNL',
    referer: 'chengbaomall'
  },
}
